import React from 'react'

import { Card } from 'components'
import { COLORS, SPACING } from 'utils'

import AddNewDocumentation from './components/AddNewDocumentation'
interface INewDocumentation {
  handleChange: (_: any, _newValue: any) => void
}

const NewDocumentation: React.FC<INewDocumentation> = ({ handleChange }) => {
  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <AddNewDocumentation handleChange={handleChange} />
    </Card>
  )
}

export default NewDocumentation
